import React from 'react'
import styled from '@emotion/styled'

import { colors } from 'Constants'

import { propertyGenerator } from 'lese'

const TextProperties = propertyGenerator([
  ['align', { property: 'text-align', default: 'center' }],
  ['small', () => 'font-size: 0.8em'],
  ['medium', () => 'font-size: 0.875em']
])

const Text = styled.span`
  font-family: 'proxima-nova', sans-serif;
  line-height: 1.2em;
  ${TextProperties}
`

const H1 = styled(Text)`
  font-size: 2em;
`.withComponent('h1')

const H2 = styled(Text)`
  font-size: 1.6em;
`.withComponent('h2')

const H3 = styled(Text)`
  font-size: 1.4em;
`.withComponent('h3')

const AccentText = styled(Text)`
  color: ${colors.blueText};
`

const FadedText = styled(Text)`
  color: ${colors.textLight};
`

const ErrorText = styled(Text)`
  color: ${colors.red};
`

const SuccessText = styled(Text)`
  color: ${colors.green};
`

const LabelWithTitle = ({ title, children }) => (
  <div>
    <FadedText small>{title}: </FadedText>
    <Text small>{children}</Text>
  </div>
)

export { Text, H1, H2, H3, AccentText, FadedText, ErrorText, SuccessText, LabelWithTitle }
